export default {
  gpsr: {
    upload: {
      replaceAria: "Replace {{title}}",
      uploadAria: "Upload {{title}}",
    },
    wizard: {
      editTitle: "Edit Product Label (GPSR)",
      createTitle: "Create Product Label (GPSR)",
      placeholder: "This step will be available in a later update. Use Continue to move through the wizard, or Products to exit.",
      subtitle: "Add product safety and compliance details for this digital label.",
      loadFailedBody: "Product Label data could not be loaded. An existing label may already be linked to this product. Retry before continuing.",
      optionsFallback: "Could not load product label options. Using local defaults.",
      deleteTextileTitle: "Delete textile component?",
      deleteTextileBody: "This component will be removed from the fibre composition list. You can add it again later if needed.",
      missingProduct: "Open this wizard from a product on the Products page. A product is required to create or edit a Product Label.",
    },
    errors: {
      loadLabels: "Failed to load product labels",
      loadLabel: "Failed to load product label",
      productNameRequired: "Product name is required",
      saveTraceabilityFirst: "Save Product traceability first to create this Product Label.",
      createLabel: "Failed to create product label",
      noId: "Product Label was created but no id was returned.",
      updateLabel: "Failed to update product label",
      saveLabel: "Failed to save product label",
      loadFibre: "Failed to load fibre components",
      generateQr: "Failed to generate product label QR code",
      qrUnavailable: "Product Label QR code or status is not available yet. Please try again.",
      generateLabel: "Failed to generate product label",
      saveBeforePrint: "Save Product traceability first to create this Product Label before printing.",
      qrNotReady: "A digital label QR code is not available yet. Continue through Product Label setup and try again.",
    },
    fibre: {
      errors: {
        componentType: "Component type is required",
        fibreType: "Fibre type is required",
        fibreDuplicate: "Fibre type already selected",
        percentageRequired: "Percentage is required",
        invalidNumber: "Enter a valid number",
        min: "Must be greater than 0",
        max: "Must be at most 100",
        atLeastOne: "Add at least one complete fibre row",
        total: "Fibre percentages must total exactly 100%",
        payload: "Fibre component payload is incomplete.",
        update: "Failed to update fibre component",
        create: "Failed to create fibre component",
        savedNoRefresh: "Fibre component was saved but the list could not be refreshed.",
        createdNoRefresh: "Fibre component was created but the list could not be refreshed.",
        delete: "Failed to delete fibre component",
        saveFirst: "Save Product traceability first to create this Product Label before managing fibre components.",
        noServerId: "This textile component cannot be updated or deleted because it has no server id. Reload the label and try again.",
      },
      totalComplete: "Total: 100%",
      totalRemaining: "Total: {{total}}% — {{remaining}}% remaining",
      totalExceeds: "Total: {{total}}% — exceeds by {{excess}}%",
      intro: "Add textile components and their fibre percentages for this product label.",
      empty: "No textile components yet",
      incomplete: "Fibre composition is incomplete",
      incompleteEdit: "Percentages for this component must total 100% before changes can be saved.",
      incompleteAdd: "Percentages for this component must total 100% before it can be added.",
      fibreType: "Fibre type",
      selectFibreType: "Select fibre type",
      percentage: "Percentage",
      removeFibre: "Remove fibre",
      addFibre: "Add fibre",
      editTitle: "Edit textile component",
      addTitle: "Add textile component",
      fibreTypeAria: "Fibre type {{number}}",
      percentageAria: "Fibre percentage {{number}}",
    },
    steps: {
      files: {
        label: "Files",
        description: "Upload brand logo, product photo and declaration of conformity.",
      },
      traceability: {
        label: "Product traceability",
        description: "Capture product identification and origin details.",
      },
      manufacturer: {
        label: "Manufacturer & Representative",
        description: "Confirm manufacturer details and Authorized Representative.",
      },
      fibre: {
        label: "Fibre composition",
        description: "Describe fibre components and percentages.",
      },
      safety: {
        label: "Safety information",
        description: "Add product safety warnings, use restrictions and care instructions.",
      },
      preview: {
        label: "GPSR Label & Digital Link",
        description: "Review your completed label, print it, or copy the digital link.",
      },
    },
    safety: {
      errors: {
        temperature: "Enter a temperature greater than 0",
        customWarning: "Enter a custom warning",
      },
      infoPlaceholder: "Add safety warnings, precautions or instructions",
      restrictions: "Approved use restrictions",
      selectRestrictions: "Select use restrictions",
      maxTemperature: "Maximum liquid temperature",
      otherWarning: "Other warning",
      minimumAge: "Minimum user age",
      selectMinimumAge: "Select minimum user age",
      careSymbols: "Care symbols",
      selectCareSymbols: "Select care symbols",
      careInstructions: "Additional care instructions",
      careInstructionsPlaceholder: "Add any additional textile care instructions",
      otherPlaceholder: "Add any additional safety or care information",
    },
    files: {
      intro: "Upload optional brand and product assets for this digital label.",
      productPhoto: "Product photo",
      photoHelper: "JPG or PNG. Use a well-lit product photo.",
      declaration: "Declaration of conformity",
      declarationHelper: "PDF only. Max size 50 MB.",
    },
    final: {
      notAvailable: "Product label is not available yet.",
    },
    manufacturer: {
      intro: "Confirm the brand owner details. Authorized Representative is managed on the product and shown here for reference.",
      importerInfo: "You do not need to list separate importer information if the company importing the goods into the European Union is legally considered the ‘Manufacturer’ under the General Product Safety Regulation (GPSR).",
      importerHint: "Add importer details for this digital label.",
    },
    traceability: {
      intro: "Capture product identification and origin details for this digital label.",
      productType: "Type of product",
      selectProductType: "Select type of product",
      expiryDate: "Expiry date",
      expiryHint: "For food, cosmetics or other applicable categories.",
      countryOfOrigin: "Country of origin",
      selectCountryOfOrigin: "Select country of origin",
      barcode: "GTIN, EAN or barcode",
      colour: "Colour or variant",
      model: "Model",
      gpcCode: "GPC Code",
    },
  },
};
